import React from 'react';

function HamburgerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg 
      width="32" 
      height="33" 
      viewBox="0 0 32 33" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 16.4972H28M4 8.49722H28M4 24.4972H28" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default HamburgerIcon;
